module.exports = __webpack_public_path__ + "img/lot_brush_street_cars_filtered.cf3c389b.jpg";